import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { MarginSchemeKindQuery, MarginSchemeKindQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(MarginSchemeKindQuery)
@Wrapper(MarginSchemeKindQueryHandlerBase)
export class MarginSchemeKindQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
